// src/hooks/useSearchTrends.js
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function useSearchTrends(initialDays = 30) {
    const [days, setDays] = useState(initialDays);
    const [items, setItems] = useState([]); // [{date: 'YYYY-MM-DD', count: N}]
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchTrends = useCallback(async (d = days) => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/stats/search/trends?days=${d}`, { timeout: 15000 });
            const data = res.data || {};
            setItems(Array.isArray(data.items) ? data.items : []);
            setDays(data.days || d);
        } catch (e) {
            console.error(e);
            setError(e?.response?.data?.error || e?.message || "Konnte Trenddaten nicht laden.");
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [days]);

    useEffect(() => { fetchTrends(initialDays); }, []); // initial load

    return { days, setDays, items, loading, error, fetchTrends };
}
